import { resolve } from 'node:path'
import { Command } from 'commander'
import {
  defaultExportDirectory,
  exportDurableStreams,
  normalizeBaseUrl,
} from '../../lib/durable-stream-archive.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printJson, printKeyValue, printQuiet } from '../../output.js'

interface ExportOptions {
  serviceUrl: string
  readToken: string
  output?: string
}

export const durableStreamsExportCommand = new Command(`export`)
  .description(`Export all streams in a service to a tar.gz archive`)
  .requiredOption(
    `--service-url <url>`,
    `Durable Streams service URL, ending in the service ID`
  )
  .requiredOption(`--read-token <token>`, `Service read token`)
  .option(`--output <folder>`, `Output folder; defaults to a timestamped name`)
  .action(async (options: ExportOptions) => {
    const json =
      durableStreamsExportCommand.parent?.parent?.opts().json ?? false

    try {
      const result = await exportDurableStreams(
        {
          serviceUrl: normalizeBaseUrl(options.serviceUrl),
          readToken: options.readToken,
          outputDirectory: resolve(options.output ?? defaultExportDirectory()),
        },
        {
          log: isQuiet()
            ? () => undefined
            : (message) => process.stderr.write(`${message}\n`),
        }
      )

      if (isQuiet()) {
        printQuiet(result.archive)
      } else if (json) {
        printJson(result)
      } else {
        printKeyValue([
          [`Streams:`, String(result.streamCount)],
          [`Directory:`, result.directory],
          [`Archive:`, result.archive],
        ])
      }
    } catch (error) {
      await handleError(error, json, `durable-streams export`)
    }
  })
